var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.875C8.75 10.5303 8.8179 10.1889 8.94982 9.87046C9.08173 9.55198 9.27509 9.2626 9.51884 9.01884C9.7626 8.77509 10.052 8.58173 10.3705 8.44982C10.6889 8.3179 11.0303 8.25 11.375 8.25C11.7197 8.25 12.0611 8.3179 12.3795 8.44982C12.698 8.58173 12.9874 8.77509 13.2312 9.01884C13.4749 9.2626 13.6683 9.55198 13.8002 9.87046C13.9321 10.1889 14 10.5303 14 10.875C14 11.5712 13.7234 12.2389 13.2312 12.7312C12.7389 13.2234 12.0712 13.5 11.375 13.5C10.6788 13.5 10.0111 13.2234 9.51884 12.7312C9.02656 12.2389 8.75 11.5712 8.75 10.875Z",
    fill: "url(#paint0_linear_227_2516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.25C7.115 2.25 2.75 6.615 2.75 12C2.75 17.385 7.115 21.75 12.5 21.75C17.885 21.75 22.25 17.385 22.25 12C22.25 6.615 17.885 2.25 12.5 2.25ZM11.375 6.75C10.7286 6.75013 10.0913 6.90217 9.5144 7.19386C8.93755 7.48556 8.43732 7.90874 8.05406 8.42927C7.6708 8.94981 7.41524 9.55313 7.30799 10.1906C7.20074 10.828 7.2448 11.4818 7.43662 12.0991C7.62843 12.7164 7.96264 13.2799 8.41228 13.7443C8.86192 14.2087 9.41441 14.561 10.0252 14.7726C10.636 14.9843 11.2879 15.0494 11.9285 14.9628C12.5691 14.8762 13.1804 14.6402 13.713 14.274L15.72 16.28C15.7887 16.3537 15.8715 16.4128 15.9635 16.4538C16.0555 16.4948 16.1548 16.5168 16.2555 16.5186C16.3562 16.5204 16.4562 16.5018 16.5496 16.4641C16.643 16.4264 16.7278 16.3703 16.799 16.299C16.8703 16.2278 16.9264 16.143 16.9641 16.0496C17.0018 15.9562 17.0204 15.8562 17.0186 15.7555C17.0168 15.6548 16.9948 15.5555 16.9538 15.4635C16.9128 15.3715 16.8537 15.2887 16.78 15.22L14.774 13.213C15.2001 12.5936 15.4488 11.8696 15.4933 11.1191C15.5378 10.3687 15.3764 9.62031 15.0265 8.95494C14.6765 8.28956 14.1514 7.73247 13.5079 7.34386C12.8643 6.95525 12.1268 6.7499 11.375 6.75Z",
    fill: "url(#paint1_linear_227_2516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_2516",
    x1: 11.375,
    y1: 8.25,
    x2: 11.375,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#982815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_227_2516",
    x1: 12.5,
    y1: 2.25,
    x2: 12.5,
    y2: 21.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#982815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7878"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fb5f58c1f003b38509d66e49ab0fb561.svg";
export { ForwardRef as ReactComponent };